import { tns } from 'tiny-slider/src/tiny-slider';

(function () {
  const testimonialsElement = document.querySelectorAll(
    '[data-vanilla="testimonials-slider"]'
  );

  if (testimonialsElement.length) {
    const observer = new MutationObserver(() => {
      tns({
        container: '#ml-wrapper',
        items: 3,
        autoplay: false,
        autoplayButtonOutput: false,
        lazyload: true,
        controlsText: ['', ''],
        nav: true,
        gutter: 43,
        loop: false,
        responsive: {
          320: {
            items: 1
          },
          640: {
            items: 2,
            gutter: 20
          },
          991: {
            items: 3,
            gutter: 25
          }
        }
      });
    });
    const config = { attributes: true, childList: true, characterData: true };
    observer.observe(testimonialsElement[0], config);
  }
})();
